import { Component, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

@Component({
  selector: 'app-back-redirector',
  templateUrl: './back-redirector.component.html',
  styleUrls: ['./back-redirector.component.scss']
})
export class BackRedirectorComponent implements OnInit {

  constructor(private router: Router, ) { }

  ngOnInit(): void {

    console.log("Activated route: ")
  }

}
